/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub
     */
    HubUrl: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub {
    if (!('HubUrl' in value) || value['HubUrl'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub {
    if (json == null) {
        return json;
    }
    return {
        
        'HubUrl': json['hub_url'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hub_url': value['HubUrl'],
    };
}

